import React, { useState } from "react";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

const EditableBlockList = () => {
  const { transcript, resetTranscript, listening } = useSpeechRecognition();
  const [summary, setSummary] = useState('');

  const handleRecording = () => {
    if (listening) {
      SpeechRecognition.stopListening();  // Stoppe la transcription
    } else {
      SpeechRecognition.startListening({ continuous: true, language: 'fr-FR' });  // Démarre la transcription
    }
  };

  // const handleSummary = async () => {
  //   const response = await fetch('/api/summarize', {  // Appel au serveur pour résumer
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ text: transcript })
  //   });
  //   const data = await response.json();
  //   setSummary(data.summary);  // Mettre à jour l'état du résumé
  // };

  return (
    <div className="container py-4" style={{ width: '80%' }}>
      <div className="d-flex justify-content-between">
        {/* <div>
          <p><strong>Name :</strong> Markiz Oceane Malwine</p>
          <p><strong>Gender :</strong> Female</p>
          <p><strong>Age :</strong> 24 years Old</p>
        </div> */}
        <div>
          <button 
            className="btn btn-success text-white px-4 py-2"
            style={{ background: '#1A5D1A' }}
            onClick={handleRecording}
          >
            {listening ? 'Stop Recording' : 'Start Recording'}
            <i className="bi bi-mic"></i>
          </button>
        </div>
      </div>

      <div className="mb-4 mt-3" style={{ border: '1px dashed #0056B3', borderRadius: '10px' }}>
        <p className="text-center py-3 fw-bold" style={{ background: '#FF980017' }}>Hearing ...</p>
        <p className="mt-3 px-3">{transcript}</p>
        {/* <button onClick={handleSummary} className="btn btn-info">Get Summary</button> */}
        {/* {summary && (
          <div className="mt-3">
            <p><strong>Summary:</strong></p>
            <p>{summary}</p>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default EditableBlockList;
